<template>
    <section class="tile h-100 mb-2">
        <div class="container h-100 mw-100 border-2 bg-dark ">
            <div class="row h-100">
                <div class="d-flex flex-column px-0 h-100 w-100 bg-header-tile align-items-stretch">
                    <div class="flex-grow-1">
                        <div class="h-100 d-flex flex-column justify-content-center align-content-center text-center px-1">
                            <div class="mt-0 mx-auto">
                                <div class="text-center text-white title-align pt-1" style="font-size: 3rem">
                                    <span
                                        :class="attributesTile.icon"
                                        class="text-primary"
                                    />
                                </div>
                            </div>

                            <div v-for="attribute in attributesTile.attributes" class="row bg-dark p-1">
                                <div class="col-12 bg-header-tile">
                                    <span class="h4 text-center text-white" v-html="attribute.description" />
                                </div>
                            </div>

                            <div v-if="attributesTile.linkUrl != null" class="row bg-dark d-flex justify-content-center pb-1">
                                <div class="col-12">
                                    <a
                                        class="btn btn-secondary btn-inverse border-white w-100"
                                        target="_self"
                                        :href="attributesTile.linkUrl"
                                        data-oevent-category="attribut_offre"
                                        data-oevent-action="s_identifier"
                                        :data-oevent-label="attributesTile.linkUrl"
                                        v-text="attributesTile.linkLabel"
                                    />
                                </div>
                            </div>

                            <div v-if="attributesTile.popin != null" class="row bg-dark d-flex justify-content-center alert-content pb-1">
                                <div class="col-12">
                                    <a
                                        target="_self"
                                        :href="'#'+ attributesTile.popin.crossDiscountPopin.modal.id"
                                        data-bs-toggle="modal"
                                        data-oevent-category="ouverture_popin"
                                        data-oevent-label="attributs_offre"
                                        data-oevent-action="remise-popin"
                                        class="ob1-link-arrow ob1-link-reverse"
                                        v-text="attributesTile.popin.popinLinkLabel"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {
    name: "DiscountedInternetOfferTile",
    components: {

    },
    props: {
        attributesTile: {type: Object, required: true},
    },
    computed: {
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">

</style>
